import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionStrip from 'components/ModeStrip/Strip';
import CustomToggle from 'components/Basic/CustomToggle/CustomToggle';
import { selectCustomMap } from 'store/selectors/customMapSelector';
import { resetCustomMap, setIsCalibrating, toggleImageEditing } from 'store/slices/CustomMapSlice';
import { clearToolModeHandlers, registerToolModeHandlers } from 'components/tool/Editor/ToolRegistry';
import { TOOL_ACTION } from 'store/selectors/toolSelector';
import { Location } from 'assets/svg';

export default function ImageEditorStrip() {
	const { isCalibrating, baselineSelectedMap, selectedMap } = useSelector(selectCustomMap);
	const dispatch = useDispatch();

	useEffect(() => {
		const cancelHandler = () => {
			if (baselineSelectedMap) {
				dispatch(resetCustomMap(baselineSelectedMap));
			}
			dispatch(toggleImageEditing({ isOpen: false }));
		};

		registerToolModeHandlers(TOOL_ACTION.EDIT_CUSTOM_IMAGE, {
			cancel: cancelHandler,
			cancelConfirmMessage: `Are you sure you want to discard changes to ${selectedMap!.fileName!}?`
		});

		return () => {
			clearToolModeHandlers(TOOL_ACTION.EDIT_CUSTOM_IMAGE);
		};
	}, [baselineSelectedMap, dispatch, selectedMap]);

	return (
		<ActionStrip
			icon={<Location />}
			action="Edit Image"
			
		>
			<div style={{ paddingInline: '8px' }}>
				<CustomToggle
					title='Adjust scale'
					checked={isCalibrating}
					onChange={() => dispatch(setIsCalibrating({ enabled: !isCalibrating }))}
					disabled={false}
				/>
			</div>
		</ActionStrip>
	);
}
